export default __webpack_public_path__ + "static/media/nfchead.1d401fe1.jpg";